import { render } from "./WaitForData.vue?vue&type=template&id=546b3a81"
import script from "./WaitForData.vue?vue&type=script&lang=js"
export * from "./WaitForData.vue?vue&type=script&lang=js"

import exportComponent from "D:\\data\\work\\interfase\\crypto\\demo\\bio-web-client\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__